export default {
  labels: {
    today: 'Heute',
    date: 'Datum',
    time: 'Zeit',
  },
  feedback: {
    selected_time_invalid:
      'Das ausgewählte Datum oder die Uhrzeit ist leider nicht verfügbar. Bitte ändern Sie die Bestellzeit',
  },
};
